<script lang="ts">
import { fade } from "svelte/transition";

export let isLoading: boolean = false;
export let duration: number   = 100;

let className = "table";
export { className as class };

</script>

<style>

.loading {
	position:   absolute;
	top:        0;
	left:       0;
	width:      100%;
	height:     100%;
}

.loading-content {
	position:  absolute;
	top:       1rem;
	left:      50%;
	transform: translateX(-50%);
}

</style>

{#if isLoading}
	<div class="loading {className}" transition:fade="{{ duration }}">
		<div class="loading-content">
			<slot>Loading...</slot>
		</div>
	</div>
{/if}
